<template>
    <div
        v-if="friendType"
        class="badge-friend-type badge badge-brd"
        :class="{
            recommended: friendType === 'recommended',
            normal: friendType === 'normal',
            'premium-badge': isPremium,
        }"
        v-html="$translate(friendTypeLabel)"
    />
</template>

<script>
export default {
    name: 'BadgeFriendType',
    props: ['chat', 'user'],
    computed: {
        friendType() {
            if (this.chat && !this.chat.expire_at) return 'normal'
            else return 'recommended'
        },
        isPremium() {
            return this.user.$$premium
        },
        friendTypeLabel() {
            if (this.user.$$premium) return `FRIEND_TYPE_PREMIUM`

            const chat = this.chat || this.$getChat(this.user.id)
            if (chat && chat.expire_at) {
                if (this.$moment(chat.expire_at).diff(this.$moment(), 'days') === 0) {
                    return `${this.$moment(chat.expire_at).diff(this.$moment(), 'hours')}시간 남음`
                } else {
                    return `D-${this.$moment(chat.expire_at).diff(this.$moment(), 'days')}`
                }
            } else if (chat) {
                return `FRIEND_TYPE_NORMAL`
            } else {
                return `FRIEND_TYPE_RECOMMENDED`
            }
        },
    },
}
</script>
